module.exports = fetch;